import Modal from 'antd/lib/modal/Modal';
import Typography from 'antd/lib/typography';

import { IconAlertTriangle, IconDroplet, IconWind, IconEye, IconThermometer } from '@tabler/icons-react'

import styles from './weather-modal.module.css';

const { Text } = Typography;

export default function WeatherModal({ selectedWeather, showWeatherModal, setShowWeatherModal, isExtremeWeather, getWindDirection }) {
    return (
        <Modal
        title={`Weather Details - ${selectedWeather.isCurrentWeather ? 'Current' : selectedWeather.time}`}
        open={showWeatherModal}
        onCancel={() => setShowWeatherModal(false)}
        footer={null}
        width={700}
        getContainer={false}
      >
        <div className={styles.weatherModalContent}>
          <div className={styles.weatherModalMain}>
            <div className={styles.weatherModalTemp}>
              <div>
                <span className={styles.tempValue}>{selectedWeather.temperature}°</span>
                <span className={styles.tempUnit}>C</span>
              </div>
              <Text type="secondary" style={{ fontSize: '14px' }}>
                Feels like {selectedWeather.feelslike}°C
              </Text>
            </div>
            <div className={styles.weatherModalConditions}>
              <Text strong style={{ fontSize: '18px' }}>{selectedWeather.conditions}</Text>
              {isExtremeWeather && (
                <IconAlertTriangle size={20} className={styles.warningIcon} />
              )}
            </div>
          </div>

          <div className={styles.weatherModalDetails}>
            {/* Precipitation Details */}
            <div className={styles.weatherModalDetail}>
              <div className={styles.detailHeader}>
                <IconDroplet size={18} />
                <Text type="secondary">Precipitation</Text>
              </div>
              <div className={styles.detailContent}>
                <div>
                  <Text strong>
                    {selectedWeather.precipitation?.probability}% chance of {selectedWeather.precipitation?.type || 'precipitation'}
                  </Text>
                  {selectedWeather.precipitation?.intensity > 0 && (
                    <Text>Intensity: {selectedWeather.precipitation.intensity} mm/hr</Text>
                  )}
                  {selectedWeather.precipitation?.snow > 0 && (
                    <Text>Snow: {selectedWeather.precipitation.snow} cm</Text>
                  )}
                  {selectedWeather.precipitation?.snowdepth > 0 && (
                    <Text>Snow Depth: {selectedWeather.precipitation.snowdepth} cm</Text>
                  )}
                </div>
              </div>
            </div>

            {/* wind details */}
            <div className={styles.weatherModalDetail}>
              <div className={styles.detailHeader}>
                <IconWind size={18} />
                <Text type="secondary">Wind</Text>
              </div>
              <div className={styles.detailContent}>
                <div>
                  <Text strong>{selectedWeather.wind?.speed} km/h</Text>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <IconWind 
                      size={16} 
                      style={{ transform: `rotate(${selectedWeather.wind?.direction}deg)` }} 
                    />
                    <Text>{getWindDirection(selectedWeather.wind?.direction)}</Text>
                  </div>
                  {selectedWeather.wind?.gust > 0 && (
                    <Text>Gusts up to {selectedWeather.wind.gust} km/h</Text>
                  )}
                </div>
              </div>
            </div>

            {/* visibility and uv */}
            <div className={styles.weatherModalDetail}>
              <div className={styles.detailHeader}>
                <IconEye size={18} />
                <Text type="secondary">Visibility & UV</Text>
              </div>
              <div className={styles.detailContent}>
                <div>
                  <Text>Visibility: {selectedWeather.visibility} km</Text>
                  <Text>UV Index: {selectedWeather.uvindex}</Text>
                </div>
              </div>
            </div>

            {/* additional details */}
            <div className={styles.weatherModalDetail}>
              <div className={styles.detailHeader}>
                <IconThermometer size={18} />
                <Text type="secondary">Additional Details</Text>
              </div>
              <div className={styles.detailContent}>
                <div className={styles.additionalDetails}>
                  <div>
                    <Text type="secondary">Humidity</Text>
                    <Text strong>{selectedWeather.humidity}%</Text>
                  </div>
                  <div>
                    <Text type="secondary">Pressure</Text>
                    <Text strong>{selectedWeather.pressure} mb</Text>
                  </div>
                  <div>
                    <Text type="secondary">Cloud Cover</Text>
                    <Text strong>{selectedWeather.cloudcover}%</Text>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
}